import DebugObject from '@/etc/debug.object'
import { v4 as Uuid } from 'uuid';
import * as TWEEN from '@tweenjs/tween.js'
import { EASING_FN } from '@/etc/consts'

export class AbstractEffect extends DebugObject {

  constructor(suuid, uuid) {
    super()
    this._uuid = uuid || Uuid()
    this._object = suuid
    this._bpm = 0
    this._time = 0
    this._span = null
    this._power = 100
    this._tweens = {}
    this._tws = {}
    this._twv = {}
    this._updateResolve = null
    this._preset = null
    this._linkedStrip = null
    this._scene = null

    this._twGroup = new TWEEN.Group()
    this._twLastTime = 0
  }

  static metaInfo() {
    return {
      uuid: 'abstract',
      name: 'Abstract',
      code: 'abstract',
      apply: []
    }
  }

  get type() { return 'effect' }
  set type(next) {}

  get bpm() { return this._bpm }
  set bpm(next) {}
  setBpm(next) { this._bpm = next }

  get uuid() { return this._uuid }
  set uuid(next) {}

  get time() { return this._time }
  set time(next) {
    this._time = next
    this.dbg.log('set time', this._time, next)
  }

  get power() { return this._power }
  set power(next) {}

  get isPreset() { return !!this._preset }
  set isPreset(next) {}

  get preset() { return this._preset }
  set preset(next) { this._preset = next }

  info() {
    const meta = this.constructor.metaInfo()
    return {
      ...meta,
      uuid: this._uuid,
      bpm: this._bpm,
      time: this._time,
      span: this._span,
      power: this._power,
      object: this._object,
      preset: this._preset,
      tweens: this._tweens,
      linkedStrip: this._linkedStrip,
      scene: this._scene
    }
  }

  configure(data) {
    // Belt+suspenders: keep host strip binding in sync (effects serialize host under `object`)
    const nextHost = data && (data.object || data.strip)
    if (typeof nextHost !== 'undefined') {
      this._object = nextHost
    }
    if (typeof data.time !== 'undefined')
      this._time = data.time
    if (typeof data.span !== 'undefined')
      this._span = data.span
    this._shift = data.shift
    this._bpm = data.bpm
    this._tweens = data.tweens
    if (data.linkedStrip)
      this._linkedStrip = data.linkedStrip
    if (data.scene)
      this._scene = data.scene
    this.buildTween()
  }

  buildTween() {
    Object.keys(this._tws || {}).forEach(id => {
      this._tws[id].stop()
    })
    this._tws = {}
    this._twv = {}
    Object.keys(this._tweens || {}).forEach(twid => {
      const twc = this._tweens[twid]
      this.dbg.log('tween', twid, twc)
      if (!twc) return
      let twlen = twc.loop * (60/this._bpm)
      try {
        const store = require('@/store').default
        const { makeBeatCode } = require('@/etc/beatcode')
        const bc = makeBeatCode(store.state.project.settings)
        twlen = twc.loop * bc.secondsPerQuarter()
      } catch (e) {
        // fallback to bpm-based seconds per beat if BeatCode is unavailable
        twlen = twc.loop * (60/this._bpm)
      }
      const tween = new TWEEN.Tween({ x: twc.limits.min }, this._twGroup)
      // const min
      tween.easing(EASING_FN[twc.easing])
      tween.to({ x: twc.limits.max }, Math.floor(twlen * 1000))
      if (twc.repeat === -1)
        tween.repeat(Infinity)
      else
        tween.repeat(twc.repeat)
      tween.yoyo(twc.yoyo)
      tween.onUpdate(({ x }) => {
        this.dbg.log('onTweenUpdate', x )
        this._twv[twid] = x
      })
      tween.start(0)
      this._tws[twid] = tween
    })
  }

  value(time, twid = null) {
    if (!twid) return 1
    if (!this._tws[twid] || time < this._twLastTime) {
      this.buildTween()
    }
    this._twGroup.update(Math.floor(time * 1000))
    this._twLastTime = time
    return this._twv[twid] * (this._power / 100)
  }

  frame(time, props) {
    return props
  }

  postprocess(cfg, pass) {
    return pass
  }
}
